import { useConfiguration } from './useConfiguration'

export const useEnvConfig = () => {
  return useConfiguration().envConfig
}

export default useEnvConfig
